import Vue from 'vue'
import ElementUI from 'element-ui'
import axios from "axios"
import { message } from '@/api/resetMsg'
import {GetCookie,DelCookie} from '@/api/cookie'
Vue.use(ElementUI)

const Axios = axios.create({
  baseURL:'https://admin.beimen.com/api/v1',
})

if(GetCookie('token')){
  Axios.defaults.headers.common['Authorization']=GetCookie('token');
}

Axios.interceptors.request.use(function (config) {
  return config;
}, function (error) {
  return Promise.reject(error);
})

Axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if(error.response){
    switch(error.response.status){
      case 401:
      DelCookie("token")
      DelCookie("real_auth")
      DelCookie("v")
      DelCookie("name")
      DelCookie("icon")
      // localStorage.removeItem('closeLoginPage')
      // localStorage.removeItem('reloadLoginPage')
      setTimeout(()=>{
        window.location.href='/home.html' 
      },700)
      message.error({
        message:'未授权  请重新登录！',
        type:'error',
        center:true,
        offset:100,
        duration:600
      })
    }
  }
  return Promise.reject(error);
})

export default {
  // get请求
  get(url, param) {
    return new Promise((resolve, reject) => {
      return Axios({
        method: "get",
        url,
        params: param,
      })
        .then(res => {
          resolve(res)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  // post请求
  post(url, param) {
    return new Promise((resolve, reject) => {
      Axios({
        method: "post",
        url,
        data: param,
      })
        .then(res => {
            resolve(res)
        })
        .catch(e => {
          reject(e)
        })
    })
  }
}
